(() => {
  const STORAGE_KEY = 'm-compare-products';
  const MAX_PRODUCTS = 4;
  const ADDED_CLASS = 'added-to-compare';
  let dockTimer = null;

  const read = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed)
        ? [...new Set(parsed.filter(Boolean))].slice(0, MAX_PRODUCTS)
        : [];
    } catch (error) {
      return [];
    }
  };

  const write = (items) => {
    const clean = [...new Set(items.filter(Boolean))].slice(0, MAX_PRODUCTS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(clean));
    return clean;
  };

  const isComparePage = () =>
    window.location.pathname.replace(/\/$/, '').endsWith('/pages/produktvergleich');

  const previewParams = () => {
    const source = new URLSearchParams(window.location.search);
    const keep = new URLSearchParams();
    ['preview_theme_id', 'preview_key', '_ab', 'pb'].forEach((key) => {
      if (source.has(key)) keep.set(key, source.get(key));
    });
    return keep;
  };

  const compareUrl = () => {
    const root =
      window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root
        : '/';
    const url = new URL(root.replace(/\/$/, '') + '/pages/produktvergleich', window.location.origin);
    previewParams().forEach((value, key) => url.searchParams.set(key, value));
    return url.pathname + url.search;
  };

  const getHandle = (button) =>
    button && button.dataset ? String(button.dataset.productHandle || '') : '';

  const setButtonState = (button, active) => {
    if (!button) return;
    button.classList.toggle(ADDED_CLASS, active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    const text = button.querySelector('.m-compare-button-text, .m-tooltip__content');
    if (!text) return;
    if (!text.dataset.compareAdd) text.dataset.compareAdd = text.textContent.trim() || 'Vergleichen';
    if (!text.dataset.compareRemove) text.dataset.compareRemove = text.dataset.revertText || 'Aus Vergleich entfernen';
    text.textContent = active ? text.dataset.compareRemove : text.dataset.compareAdd;
  };

  const ensureDock = () => {
    let dock = document.querySelector('[data-enterprise-compare-dock]');
    if (dock) return dock;

    dock = document.createElement('div');
    dock.className = 'enterprise-compare-dock';
    dock.dataset.enterpriseCompareDock = '';
    if (previewParams().has('preview_theme_id')) dock.classList.add('is-preview');
    dock.innerHTML =
      '<div class="enterprise-compare-dock__inner">' +
        '<a class="enterprise-compare-dock__main" data-enterprise-compare-open href="' + compareUrl() + '">' +
          '<div class="enterprise-compare-dock__status">' +
            '<strong data-enterprise-compare-count>0</strong>' +
            '<span data-enterprise-compare-label>Produkte ausgewählt</span>' +
          '</div>' +
          '<span class="enterprise-compare-dock__cta">Jetzt vergleichen →</span>' +
        '</a>' +
        '<button type="button" class="enterprise-compare-dock__clear" data-enterprise-compare-clear aria-label="Vergleichsauswahl löschen">×</button>' +
      '</div>';
    document.body.appendChild(dock);
    return dock;
  };

  const refresh = () => {
    const items = read();
    document.querySelectorAll('.m-compare-button').forEach((button) => {
      const handle = getHandle(button);
      setButtonState(button, !!handle && items.includes(handle));
    });

    const dock = ensureDock();
    const count = dock.querySelector('[data-enterprise-compare-count]');
    const label = dock.querySelector('[data-enterprise-compare-label]');
    const open = dock.querySelector('[data-enterprise-compare-open]');
    if (count) count.textContent = String(items.length);
    if (label) label.textContent = items.length === 1 ? 'Produkt ausgewählt' : 'Produkte ausgewählt';
    if (open) open.href = compareUrl();

    if (isComparePage() || items.length < 2) dock.classList.remove('is-visible');
  };

  const showDock = () => {
    const items = read();
    const dock = ensureDock();
    if (isComparePage() || items.length < 2) {
      dock.classList.remove('is-visible');
      return;
    }
    dock.classList.add('is-visible');
    if (dockTimer) window.clearTimeout(dockTimer);
    dockTimer = window.setTimeout(() => dock.classList.remove('is-visible'), 6500);
  };

  const toggle = (handle) => {
    if (!handle) return;
    const items = read();
    const index = items.indexOf(handle);
    if (index >= 0) items.splice(index, 1);
    else {
      if (items.length >= MAX_PRODUCTS) items.shift();
      items.push(handle);
    }
    write(items);
    refresh();
    showDock();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.m-compare-button');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      toggle(getHandle(button));
      return;
    }

    if (event.target.closest('[data-enterprise-compare-clear]')) {
      event.preventDefault();
      write([]);
      refresh();
    }
  }, true);

  const boot = () => {
    refresh();
    ensureDock().classList.remove('is-visible');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('pageshow', boot);
  window.addEventListener('storage', refresh);
  document.addEventListener('shopify:section:load', refresh);

  window.MinimogTheme = window.MinimogTheme || {};
  window.MinimogTheme.CompareProduct = {
    setCompareButtonsState: refresh,
    refresh,
    addToCompare(handle) {
      const items = read();
      if (!items.includes(handle)) {
        if (items.length >= MAX_PRODUCTS) items.shift();
        items.push(handle);
        write(items);
      }
      refresh();
      showDock();
    },
    removeFromCompare(handle) {
      write(read().filter((item) => item !== handle));
      refresh();
    }
  };
})();